export default __webpack_public_path__ + "static/media/people_page_icon.c7da7105.svg";